'use strict'

/**
 *
 * @name: nnSplashimageModal
 *
 */
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import Template from './nn-splashimage-modal.directive.html'
import './nn-splashimage-modal.directive.scss'

function NnBlackAndWhiteModalDirective () {

  'ngInject'

  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: Template,
    controller: nnBlackAndWhiteModalDirectiveController
  }
}

function nnBlackAndWhiteModalDirectiveController ($scope, $rootScope, $element) {

  'ngInject'

  /*
   *
   * @CONFIG
   *
   */
  $scope.isModalVisible = true
  $scope.src = window.innerWidth > 420 ? 'assets/img/nowness-mesh-bg-desktop.png' : 'assets/img/nowness-mesh-bg-mobile.png'

  /*
  *
   * @PUBLIC
   *
   */


  $scope.close = () => {
    $scope.isModalVisible = false
    enableBodyScroll($element[0]);
  }

  $scope.showModal = () => {
    return $scope.isModalVisible && $rootScope.lang === 'zh-cn'
  }

  /*
   *
   * @PRIVATE
   *
   */


  /*
   *
   * @INIT
   *
   */

  if ($scope.showModal()) {
    disableBodyScroll($element[0]);
  }

}

export default NnBlackAndWhiteModalDirective



// WEBPACK FOOTER //
// ./app/components/nn-modals/nn-splashimage-modal/nn-splashimage-modal.directive.js